// Fix jQuery passive listener
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

jQuery(document).ready(function ($) {
    function debounce(func, wait) {
        var timer = null;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(func, wait);
        }
    }

    // Menu mobile vars
    var hamburger = document.querySelector(".hamburger");
    var toogleMenu = document.querySelectorAll('.toggle-menu');
    var wrapper = document.querySelector('.menu-wrapper');
    var menuMobileOverlay = $('.menu-mobile-overlay');

    for (var i = 0; i < toogleMenu.length; i++){
        toogleMenu[i].addEventListener('click', menuAction);
    }

    // Search vars
    var toggleSearch = $('[data-search="toggle"]');
    var searchOverlay = $('.search-overlay');
    var screenSearch = $('.header-search-block');

    // Open menu mobile
    function openMenuMobile() {
        menuMobileOverlay.fadeIn();
        wrapper.classList.add('show-menu');
        hamburger.classList.add('is-active');
        if (screenSearch.is(':visible')) {
            closeSearchMobile();
        }
    }

    // Close menu mobile
    function closeMenuMobile() {
        menuMobileOverlay.fadeOut();
        wrapper.classList.remove('show-menu');
        hamburger.classList.remove('is-active');
    }

    // Open search
    function openSearchMobile() {
        screenSearch.addClass('is-active');
        screenSearch.fadeIn();
        searchOverlay.fadeIn();
        screenSearch.find('.search-field').focus();
        if (wrapper.classList.contains('show-menu')) {
            closeMenuMobile();
        }
    }

    // Close search
    function closeSearchMobile() {
        screenSearch.removeClass('is-active');
        screenSearch.fadeOut();
        searchOverlay.fadeOut();
    }

    // Trigger menu mobile
    function menuAction() {
        if(wrapper.classList.contains('show-menu')){
            closeMenuMobile();
        }
        else {
            openMenuMobile();
        }
    }

    // Open submenu mobile
    $('.mobile-nav .menu-item-has-children').click(function(event) {
        $('.mobile-nav .sub-menu .menu-item').click(function(event) {
            event.stopPropagation();
        });
        if ($(this).children('.sub-menu').is(':visible')) {
            $(this).removeClass('is-active');
            $(this).children('.sub-menu').slideUp();
        } else {
            $(this).addClass('is-active');
            $(this).children('.sub-menu').slideDown();
        }
    });

    // Trigger search mobile
    $(toggleSearch).click(function() {
        if (screenSearch.hasClass('is-active')) {
            closeSearchMobile();
        } else {
            openSearchMobile();
        }
    });

    // Menu horizontal de categoria
    var catBlock = $('#cat-block');
    var catList = $('#cat-list');

    if ($("body").has("#cat-block").length) {
        var catPrev = $('#cat-prev');
        var catNext = $('#cat-next');

        if ($(catList).get(0).scrollWidth - $(catList).outerWidth() <= 0) {
            $(catBlock).addClass('no-scroll');
        }

        $(catPrev).click(function () {
            $(catList).animate({
                scrollLeft: '-=150'
            }, 300, 'swing');
        });

        $(catNext).click(function () {
            $(catList).animate({
                scrollLeft: '+=150'
            }, 300, 'swing');
        });

        $(catList).scroll(function() {
            if ($(this).scrollLeft() > 5) {
                $(catBlock).addClass('is-scrolled');
            } else if ($(catBlock).hasClass('is-scrolled')) {
                $(catBlock).removeClass('is-scrolled');
            }
            // checar se scrollou totalmente ate a direita
            var divWidth = $(this).outerWidth();
            var scrollwidth = $(this).get(0).scrollWidth;
            if($(this).scrollLeft() >= scrollwidth - divWidth - 5){
                $(catBlock).addClass('is-full-scrolled');
            } else if ($(catBlock).hasClass('is-full-scrolled')) {
                $(catBlock).removeClass('is-full-scrolled');
            }
        });
    }

    // Open footer menu
    $('#footer-menu-btn').click(function() {
        $(this).toggleClass('is-active');
        $(this).siblings('.custom-menu-class').slideToggle();
    });

    // Trigger whatsapp (open/close)
    var whatsappPopup = $('#whatsapp-popup');

    $('[data-whatsapp-popup="toggle"]').click(function(event) {
        whatsappPopup.toggleClass('is-active');
        whatsappPopup.fadeToggle('fast');
        if (whatsappPopup.hasClass('is-active')) {
            $(whatsappPopup).find('input:first').focus();
            $('html').css({'overflow': 'hidden'});
        } else {
            setTimeout(function(){
                $('html').css({'overflow': ''});
            }, 300);
        }
    });

    // Resize listener
    window.addEventListener('resize', debounce(function(){
        if ($("body").has("#cat-block").length) {
            if ($(catList).get(0).scrollWidth - $(catList).outerWidth() <= 0) {
                $(catBlock).addClass('no-scroll');
            } else {
                $(catBlock).removeClass('no-scroll');
            }
        }
    }, 100));

    // Nome do arquivo no input
    if ($("body").has("#input-file").length) {
        // click input file
        $('#input-file-btn').click(function() {
            $('#input-file').click();
        });

        var defaultText = $("#input-file-name").text();

        $('#input-file').bind('change', function(){
            $("#input-file-name").html(this.value.split(/(\\|\/)/g).pop());
            if ($('#input-file-name').is(':empty')){
                $("#input-file-name").html(defaultText);
            }
        });
    }

    // Anchor scroll
    $('a[href*="#"]:not([href="#"])').click(function (event) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var el = this;
            var hash = $($(this).attr('href'));
            var target = hash.length ? hash : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);

                // Fechar menu mobile
                closeMenuMobile();

                // Mudar hash na URL
                history.pushState({}, '', el.href);
            }
        }
    });

    $('a[href="#"]').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
        // Fechar menu mobile
        closeMenuMobile();
    });

    /*
    var hash = location.hash;

    if ($("body").has(hash).length) {
        $('html, body').animate({
            scrollTop: $($(hash).offset().top)
        }, 1000);
    }
    */

    $('.gallery-popup, .wp-block-gallery').each(function() { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            tLoading: 'Carregando a imagem...',
            mainClass: 'mfp-no-margins mfp-fade',
            removalDelay: 300,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: 'A imagem não pode ser carregada.',
            },
        });
    });
});
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlcyI6WyJtYWluLm1pbi5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyIvLyBGaXggalF1ZXJ5IHBhc3NpdmUgbGlzdGVuZXJcclxualF1ZXJ5LmV2ZW50LnNwZWNpYWwudG91Y2hzdGFydCA9IHtcclxuICAgIHNldHVwOiBmdW5jdGlvbiggXywgbnMsIGhhbmRsZSApIHtcclxuICAgICAgICB0aGlzLmFkZEV2ZW50TGlzdGVuZXIoXCJ0b3VjaHN0YXJ0XCIsIGhhbmRsZSwgeyBwYXNzaXZlOiAhbnMuaW5jbHVkZXMoXCJub1ByZXZlbnREZWZhdWx0XCIpIH0pO1xyXG4gICAgfVxyXG59O1xyXG5qUXVlcnkuZXZlbnQuc3BlY2lhbC50b3VjaG1vdmUgPSB7XHJcbiAgICBzZXR1cDogZnVuY3Rpb24oIF8sIG5zLCBoYW5kbGUgKSB7XHJcbiAgICAgICAgdGhpcy5hZGRFdmVudExpc3RlbmVyKFwidG91Y2htb3ZlXCIsIGhhbmRsZSwgeyBwYXNzaXZlOiAhbnMuaW5jbHVkZXMoXCJub1ByZXZlbnREZWZhdWx0XCIpIH0pO1xyXG4gICAgfVxyXG59O1xyXG5qUXVlcnkuZXZlbnQuc3BlY2lhbC53aGVlbCA9IHtcclxuICAgIHNldHVwOiBmdW5jdGlvbiggXywgbnMsIGhhbmRsZSApe1xyXG4gICAgICAgIHRoaXMuYWRkRXZlbnRMaXN0ZW5lcihcIndoZWVsXCIsIGhhbmRsZSwgeyBwYXNzaXZlOiB0cnVlIH0pO1xyXG4gICAgfVxyXG59O1xyXG5qUXVlcnkuZXZlbnQuc3BlY2lhbC5tb3VzZXdoZWVsID0ge1xyXG4gICAgc2V0dXA6IGZ1bmN0aW9uKCBfLCBucywgaGFuZGxlICl7XHJcbiAgICAgICAgdGhpcy5hZGRFdmVudExpc3RlbmVyKFwibW91c2V3aGVlbFwiLCBoYW5kbGUsIHsgcGFzc2l2ZTogdHJ1ZSB9KTtcclxuICAgIH1cclxufTtcclxuXHJcbmpRdWVyeShkb2N1bWVudCkucmVhZHkoZnVuY3Rpb24gKCQpIHtcclxuICAgIGZ1bmN0aW9uIGRlYm91bmNlKGZ1bmMsIHdhaXQpIHtcclxuICAgICAgICB2YXIgdGltZXIgPSBudWxsO1xyXG4gICAgICAgIHJldHVybiBmdW5jdGlvbigpIHtcclxuICAgICAgICAgICAgY2xlYXJUaW1lb3V0KHRpbWVyKTtcclxuICAgICAgICAgICAgdGltZXIgPSBzZXRUaW1lb3V0KGZ1bmMsIHdhaXQpO1xyXG4gICAgICAgIH1cclxuICAgIH1cclxuXHJcbiAgICAvLyBNZW51IG1vYmlsZSB2YXJzXHJcbiAgICB2YXIgaGFtYnVyZ2VyID0gZG9jdW1lbnQucXVlcnlTZWxlY3RvcihcIi5oYW1idXJnZXJcIik7XHJcbiAgICB2YXIgdG9vZ2xlTWVudSA9IGRvY3VtZW50LnF1ZXJ5U2VsZWN0b3JBbGwoJy50b2dnbGUtbWVudScpO1xyXG4gICAgdmFyIHdyYXBwZXIgPSBkb2N1bWVudC5xdWVyeVNlbGVjdG9yKCcubWVudS13cmFwcGVyJyk7XHJcbiAgICB2YXIgbWVudU1vYmlsZU92ZXJsYXkgPSAkKCcubWVudS1tb2JpbGUtb3ZlcmxheScpO1xyXG5cclxuICAgIGZvciAodmFyIGkgPSAwOyBpIDwgdG9vZ2xlTWVudS5sZW5ndGg7IGkrKyl7XHJcbiAgICAgICAgdG9vZ2xlTWVudVtpXS5hZGRFdmVudExpc3RlbmVyKCdjbGljaycsIG1lbnVBY3Rpb24pO1xyXG4gICAgfVxyXG5cclxuICAgIC8vIFNlYXJjaCB2YXJzXHJcbiAgICB2YXIgdG9nZ2xlU2VhcmNoID0gJCgnW2RhdGEtc2VhcmNoPVwidG9nZ2xlXCJdJyk7XHJcbiAgICB2YXIgc2VhcmNoT3ZlcmxheSA9ICQoJy5zZWFyY2gtb3ZlcmxheScpO1xyXG4gICAgdmFyIHNjcmVlblNlYXJjaCA9ICQoJy5oZWFkZXItc2VhcmNoLWJsb2NrJyk7XHJcblxyXG4gICAgLy8gT3BlbiBtZW51IG1vYmlsZVxyXG4gICAgZnVuY3Rpb24gb3Blbk1lbnVNb2JpbGUoKSB7XHJcbiAgICAgICAgbWVudU1vYmlsZU92ZXJsYXkuZmFkZUluKCk7XHJcbiAgICAgICAgd3JhcHBlci5jbGFzc0xpc3QuYWRkKCdzaG93LW1lbnUnKTtcclxuICAgICAgICBoYW1idXJnZXIuY2xhc3NMaXN0LmFkZCgnaXMtYWN0aXZlJyk7XHJcbiAgICAgICAgaWYgKHNjcmVlblNlYXJjaC5pcygnOnZpc2libGUnKSkge1xyXG4gICAgICAgICAgICBjbG9zZVNlYXJjaE1vYmlsZSgpO1xyXG4gICAgICAgIH1cclxuICAgIH1cclxuXHJcbiAgICAvLyBDbG9zZSBtZW51IG1vYmlsZVxyXG4gICAgZnVuY3Rpb24gY2xvc2VNZW51TW9iaWxlKCkge1xyXG4gICAgICAgIG1lbnVNb2JpbGVPdmVybGF5LmZhZGVPdXQoKTtcclxuICAgICAgICB3cmFwcGVyLmNsYXNzTGlzdC5yZW1vdmUoJ3Nob3ctbWVudScpO1xyXG4gICAgICAgIGhhbWJ1cmdlci5jbGFzc0xpc3QucmVtb3ZlKCdpcy1hY3RpdmUnKTtcclxuICAgIH1cclxuXHJcbiAgICAvLyBPcGVuIHNlYXJjaFxyXG4gICAgZnVuY3Rpb24gb3BlblNlYXJjaE1vYmlsZSgpIHtcclxuICAgICAgICBzY3JlZW5TZWFyY2guYWRkQ2xhc3MoJ2lzLWFjdGl2ZScpO1xyXG4gICAgICAgIHNjcmVlblNlYXJjaC5mYWRlSW4oKTtcclxuICAgICAgICBzZWFyY2hPdmVybGF5LmZhZGVJbigpO1xyXG4gICAgICAgIHNjcmVlblNlYXJjaC5maW5kKCcuc2VhcmNoLWZpZWxkJykuZm9jdXMoKTtcclxuICAgICAgICBpZiAod3JhcHBlci5jbGFzc0xpc3QuY29udGFpbnMoJ3Nob3ctbWVudScpKSB7XHJcbiAgICAgICAgICAgIGNsb3NlTWVudU1vYmlsZSgpO1xyXG4gICAgICAgIH1cclxuICAgIH1cclxuXHJcbiAgICAvLyBDbG9zZSBzZWFyY2hcclxuICAgIGZ1bmN0aW9uIGNsb3NlU2VhcmNoTW9iaWxlKCkge1xyXG4gICAgICAgIHNjcmVlblNlYXJjaC5yZW1vdmVDbGFzcygnaXMtYWN0aXZlJyk7XHJcbiAgICAgICAgc2NyZWVuU2VhcmNoLmZhZGVPdXQoKTtcclxuICAgICAgICBzZWFyY2hPdmVybGF5LmZhZGVPdXQoKTtcclxuICAgIH1cclxuXHJcbiAgICAvLyBUcmlnZ2VyIG1lbnUgbW9iaWxlXHJcbiAgICBmdW5jdGlvbiBtZW51QWN0aW9uKCkge1xyXG4gICAgICAgIGlmKHdyYXBwZXIuY2xhc3NMaXN0LmNvbnRhaW5zKCdzaG93LW1lbnUnKSl7XHJcbiAgICAgICAgICAgIGNsb3NlTWVudU1vYmlsZSgpO1xyXG4gICAgICAgIH1cclxuICAgICAgICBlbHNlIHtcclxuICAgICAgICAgICAgb3Blbk1lbnVNb2JpbGUoKTtcclxuICAgICAgICB9XHJcbiAgICB9XHJcblxyXG4gICAgLy8gT3BlbiBzdWJtZW51IG1vYmlsZVxyXG4gICAgJCgnLm1vYmlsZS1uYXYgLm1lbnUtaXRlbS1oYXMtY2hpbGRyZW4nKS5jbGljayhmdW5jdGlvbihldmVudCkge1xyXG4gICAgICAgICQoJy5tb2JpbGUtbmF2IC5zdWItbWVudSAubWVudS1pdGVtJykuY2xpY2soZnVuY3Rpb24oZXZlbnQpIHtcclxuICAgICAgICAgICAgZXZlbnQuc3RvcFByb3BhZ2F0aW9uKCk7XHJcbiAgICAgICAgfSk7XHJcbiAgICAgICAgaWYgKCQodGhpcykuY2hpbGRyZW4oJy5zdWItbWVudScpLmlzKCc6dmlzaWJsZScpKSB7XHJcbiAgICAgICAgICAgICQodGhpcykucmVtb3ZlQ2xhc3MoJ2lzLWFjdGl2ZScpO1xyXG4gICAgICAgICAgICAkKHRoaXMpLmNoaWxkcmVuKCcuc3ViLW1lbnUnKS5zbGlkZVVwKCk7XHJcbiAgICAgICAgfSBlbHNlIHtcclxuICAgICAgICAgICAgJCh0aGlzKS5hZGRDbGFzcygnaXMtYWN0aXZlJyk7XHJcbiAgICAgICAgICAgICQodGhpcykuY2hpbGRyZW4oJy5zdWItbWVudScpLnNsaWRlRG93bigpO1xyXG4gICAgICAgIH1cclxuICAgIH0pO1xyXG5cclxuICAgIC8vIFRyaWdnZXIgc2VhcmNoIG1vYmlsZVxyXG4gICAgJCh0b2dnbGVTZWFyY2gpLmNsaWNrKGZ1bmN0aW9uKCkge1xyXG4gICAgICAgIGlmIChzY3JlZW5TZWFyY2guaGFzQ2xhc3MoJ2lzLWFjdGl2ZScpKSB7XHJcbiAgICAgICAgICAgIGNsb3NlU2VhcmNoTW9iaWxlKCk7XHJcbiAgICAgICAgfSBlbHNlIHtcclxuICAgICAgICAgICAgb3BlblNlYXJjaE1vYmlsZSgpO1xyXG4gICAgICAgIH1cclxuICAgIH0pO1xyXG5cclxuICAgIC8vIE1lbnUgaG9yaXpvbnRhbCBkZSBjYXRlZ29yaWFcclxuICAgIHZhciBjYXRCbG9jayA9ICQoJyNjYXQtYmxvY2snKTtcclxuICAgIHZhciBjYXRMaXN0ID0gJCgnI2NhdC1saXN0Jyk7XHJcblxyXG4gICAgaWYgKCQoXCJib2R5XCIpLmhhcyhcIiNjYXQtYmxvY2tcIikubGVuZ3RoKSB7XHJcbiAgICAgICAgdmFyIGNhdFByZXYgPSAkKCcjY2F0LXByZXYnKTtcclxuICAgICAgICB2YXIgY2F0TmV4dCA9ICQoJyNjYXQtbmV4dCcpO1xyXG5cclxuICAgICAgICBpZiAoJChjYXRMaXN0KS5nZXQoMCkuc2Nyb2xsV2lkdGggLSAkKGNhdExpc3QpLm91dGVyV2lkdGgoKSA8PSAwKSB7XHJcbiAgICAgICAgICAgICQoY2F0QmxvY2spLmFkZENsYXNzKCduby1zY3JvbGwnKTtcclxuICAgICAgICB9XHJcblxyXG4gICAgICAgICQoY2F0UHJldikuY2xpY2soZnVuY3Rpb24gKCkge1xyXG4gICAgICAgICAgICAkKGNhdExpc3QpLmFuaW1hdGUoe1xyXG4gICAgICAgICAgICAgICAgc2Nyb2xsTGVmdDogJy09MTUwJ1xyXG4gICAgICAgICAgICB9LCAzMDAsICdzd2luZycpO1xyXG4gICAgICAgIH0pO1xyXG5cclxuICAgICAgICAkKGNhdE5leHQpLmNsaWNrKGZ1bmN0aW9uICgpIHtcclxuICAgICAgICAgICAgJChjYXRMaXN0KS5hbmltYXRlKHtcclxuICAgICAgICAgICAgICAgIHNjcm9sbExlZnQ6ICcrPTE1MCdcclxuICAgICAgICAgICAgfSwgMzAwLCAnc3dpbmcnKTtcclxuICAgICAgICB9KTtcclxuXHJcbiAgICAgICAgJChjYXRMaXN0KS5zY3JvbGwoZnVuY3Rpb24oKSB7XHJcbiAgICAgICAgICAgIGlmICgkKHRoaXMpLnNjcm9sbExlZnQoKSA+IDUpIHtcclxuICAgICAgICAgICAgICAgICQoY2F0QmxvY2spLmFkZENsYXNzKCdpcy1zY3JvbGxlZCcpO1xyXG4gICAgICAgICAgICB9IGVsc2UgaWYgKCQoY2F0QmxvY2spLmhhc0NsYXNzKCdpcy1zY3JvbGxlZCcpKSB7XHJcbiAgICAgICAgICAgICAgICAkKGNhdEJsb2NrKS5yZW1vdmVDbGFzcygnaXMtc2Nyb2xsZWQnKTtcclxuICAgICAgICAgICAgfVxyXG4gICAgICAgICAgICAvLyBjaGVjYXIgc2Ugc2Nyb2xsb3UgdG90YWxtZW50ZSBhdGUgYSBkaXJlaXRhXHJcbiAgICAgICAgICAgIHZhciBkaXZXaWR0aCA9ICQodGhpcykub3V0ZXJXaWR0aCgpO1xyXG4gICAgICAgICAgICB2YXIgc2Nyb2xsd2lkdGggPSAkKHRoaXMpLmdldCgwKS5zY3JvbGxXaWR0aDtcclxuICAgICAgICAgICAgaWYoJCh0aGlzKS5zY3JvbGxMZWZ0KCkgPj0gc2Nyb2xsd2lkdGggLSBkaXZXaWR0aCAtIDUpe1xyXG4gICAgICAgICAgICAgICAgJChjYXRCbG9jaykuYWRkQ2xhc3MoJ2lzLWZ1bGwtc2Nyb2xsZWQnKTtcclxuICAgICAgICAgICAgfSBlbHNlIGlmICgkKGNhdEJsb2NrKS5oYXNDbGFzcygnaXMtZnVsbC1zY3JvbGxlZCcpKSB7XHJcbiAgICAgICAgICAgICAgICAkKGNhdEJsb2NrKS5yZW1vdmVDbGFzcygnaXMtZnVsbC1zY3JvbGxlZCcpO1xyXG4gICAgICAgICAgICB9XHJcbiAgICAgICAgfSk7XHJcbiAgICB9XHJcblxyXG4gICAgLy8gT3BlbiBmb290ZXIgbWVudVxyXG4gICAgJCgnI2Zvb3Rlci1tZW51LWJ0bicpLmNsaWNrKGZ1bmN0aW9uKCkge1xyXG4gICAgICAgICQodGhpcykudG9nZ2xlQ2xhc3MoJ2lzLWFjdGl2ZScpO1xyXG4gICAgICAgICQodGhpcykuc2libGluZ3MoJy5jdXN0b20tbWVudS1jbGFzcycpLnNsaWRlVG9nZ2xlKCk7XHJcbiAgICB9KTtcclxuXHJcbiAgICAvLyBUcmlnZ2VyIHdoYXRzYXBwIChvcGVuL2Nsb3NlKVxyXG4gICAgdmFyIHdoYXRzYXBwUG9wdXAgPSAkKCcjd2hhdHNhcHAtcG9wdXAnKTtcclxuXHJcbiAgICAkKCdbZGF0YS13aGF0c2FwcC1wb3B1cD1cInRvZ2dsZVwiXScpLmNsaWNrKGZ1bmN0aW9uKGV2ZW50KSB7XHJcbiAgICAgICAgd2hhdHNhcHBQb3B1cC50b2dnbGVDbGFzcygnaXMtYWN0aXZlJyk7XHJcbiAgICAgICAgd2hhdHNhcHBQb3B1cC5mYWRlVG9nZ2xlKCdmYXN0Jyk7XHJcbiAgICAgICAgaWYgKHdoYXRzYXBwUG9wdXAuaGFzQ2xhc3MoJ2lzLWFjdGl2ZScpKSB7XHJcbiAgICAgICAgICAgICQod2hhdHNhcHBQb3B1cCkuZmluZCgnaW5wdXQ6Zmlyc3QnKS5mb2N1cygpO1xyXG4gICAgICAgICAgICAkKCdodG1sJykuY3NzKHsnb3ZlcmZsb3cnOiAnaGlkZGVuJ30pO1xyXG4gICAgICAgIH0gZWxzZSB7XHJcbiAgICAgICAgICAgIHNldFRpbWVvdXQoZnVuY3Rpb24oKXtcclxuICAgICAgICAgICAgICAgICQoJ2h0bWwnKS5jc3MoeydvdmVyZmxvdyc6ICcnfSk7XHJcbiAgICAgICAgICAgIH0sIDMwMCk7XHJcbiAgICAgICAgfVxyXG4gICAgfSk7XHJcblxyXG4gICAgLy8gUmVzaXplIGxpc3RlbmVyXHJcbiAgICB3aW5kb3cuYWRkRXZlbnRMaXN0ZW5lcigncmVzaXplJywgZGVib3VuY2UoZnVuY3Rpb24oKXtcclxuICAgICAgICBpZiAoJChcImJvZHlcIikuaGFzKFwiI2NhdC1ibG9ja1wiKS5sZW5ndGgpIHtcclxuICAgICAgICAgICAgaWYgKCQoY2F0TGlzdCkuZ2V0KDApLnNjcm9sbFdpZHRoIC0gJChjYXRMaXN0KS5vdXRlcldpZHRoKCkgPD0gMCkge1xyXG4gICAgICAgICAgICAgICAgJChjYXRCbG9jaykuYWRkQ2xhc3MoJ25vLXNjcm9sbCcpO1xyXG4gICAgICAgICAgICB9IGVsc2Uge1xyXG4gICAgICAgICAgICAgICAgJChjYXRCbG9jaykucmVtb3ZlQ2xhc3MoJ25vLXNjcm9sbCcpO1xyXG4gICAgICAgICAgICB9XHJcbiAgICAgICAgfVxyXG4gICAgfSwgMTAwKSk7XHJcblxyXG4gICAgLy8gTm9tZSBkbyBhcnF1aXZvIG5vIGlucHV0XHJcbiAgICBpZiAoJChcImJvZHlcIikuaGFzKFwiI2lucHV0LWZpbGVcIikubGVuZ3RoKSB7XHJcbiAgICAgICAgLy8gY2xpY2sgaW5wdXQgZmlsZVxyXG4gICAgICAgICQoJyNpbnB1dC1maWxlLWJ0bicpLmNsaWNrKGZ1bmN0aW9uKCkge1xyXG4gICAgICAgICAgICAkKCcjaW5wdXQtZmlsZScpLmNsaWNrKCk7XHJcbiAgICAgICAgfSk7XHJcblxyXG4gICAgICAgIHZhciBkZWZhdWx0VGV4dCA9ICQoXCIjaW5wdXQtZmlsZS1uYW1lXCIpLnRleHQoKTtcclxuXHJcbiAgICAgICAgJCgnI2lucHV0LWZpbGUnKS5iaW5kKCdjaGFuZ2UnLCBmdW5jdGlvbigpe1xyXG4gICAgICAgICAgICAkKFwiI2lucHV0LWZpbGUtbmFtZVwiKS5odG1sKHRoaXMudmFsdWUuc3BsaXQoLyhcXFxcfFxcLykvZykucG9wKCkpO1xyXG4gICAgICAgICAgICBpZiAoJCgnI2lucHV0LWZpbGUtbmFtZScpLmlzKCc6ZW1wdHknKSl7XHJcbiAgICAgICAgICAgICAgICAkKFwiI2lucHV0LWZpbGUtbmFtZVwiKS5odG1sKGRlZmF1bHRUZXh0KTtcclxuICAgICAgICAgICAgfVxyXG4gICAgICAgIH0pO1xyXG4gICAgfVxyXG5cclxuICAgIC8vIEFuY2hvciBzY3JvbGxcclxuICAgICQoJ2FbaHJlZio9XCIjXCJdOm5vdChbaHJlZj1cIiNcIl0pJykuY2xpY2soZnVuY3Rpb24gKGV2ZW50KSB7XHJcbiAgICAgICAgZXZlbnQucHJldmVudERlZmF1bHQoKTtcclxuICAgICAgICBpZiAobG9jYXRpb24ucGF0aG5hbWUucmVwbGFjZSgvXlxcLy8sICcnKSA9PSB0aGlzLnBhdGhuYW1lLnJlcGxhY2UoL15cXC8vLCAnJykgJiYgbG9jYXRpb24uaG9zdG5hbWUgPT0gdGhpcy5ob3N0bmFtZSkge1xyXG4gICAgICAgICAgICB2YXIgZWwgPSB0aGlzO1xyXG4gICAgICAgICAgICB2YXIgaGFzaCA9ICQoJCh0aGlzKS5hdHRyKCdocmVmJykpO1xyXG4gICAgICAgICAgICB2YXIgdGFyZ2V0ID0gaGFzaC5sZW5ndGggPyBoYXNoIDogJCgnW25hbWU9JyArIHRoaXMuaGFzaC5zbGljZSgxKSArICddJyk7XHJcbiAgICAgICAgICAgIGlmICh0YXJnZXQubGVuZ3RoKSB7XHJcbiAgICAgICAgICAgICAgICAkKCdodG1sLCBib2R5JykuYW5pbWF0ZSh7XHJcbiAgICAgICAgICAgICAgICAgICAgc2Nyb2xsVG9wOiB0YXJnZXQub2Zmc2V0KCkudG9wXHJcbiAgICAgICAgICAgICAgICB9LCAxMDAwKTtcclxuXHJcbiAgICAgICAgICAgICAgICAvLyBGZWNoYXIgbWVudSBtb2JpbGVcclxuICAgICAgICAgICAgICAgIGNsb3NlTWVudU1vYmlsZSgpO1xyXG5cclxuICAgICAgICAgICAgICAgIC8vIE11ZGFyIGhhc2ggbmEgVVJMXHJcbiAgICAgICAgICAgICAgICBoaXN0b3J5LnB1c2hTdGF0ZSh7fSwgJycsIGVsLmhyZWYpO1xyXG4gICAgICAgICAgICB9XHJcbiAgICAgICAgfVxyXG4gICAgfSk7XHJcblxyXG4gICAgJCgnYVtocmVmPVwiI1wiXScpLmNsaWNrKGZ1bmN0aW9uICgpIHtcclxuICAgICAgICAkKCdodG1sLCBib2R5JykuYW5pbWF0ZSh7XHJcbiAgICAgICAgICAgIHNjcm9sbFRvcDogMFxyXG4gICAgICAgIH0sIDEwMDApO1xyXG4gICAgICAgIC8vIEZlY2hhciBtZW51IG1vYmlsZVxyXG4gICAgICAgIGNsb3NlTWVudU1vYmlsZSgpO1xyXG4gICAgfSk7XHJcblxyXG4gICAgLypcclxuICAgIHZhciBoYXNoID0gbG9jYXRpb24uaGFzaDtcclxuXHJcbiAgICBpZiAoJChcImJvZHlcIikuaGFzKGhhc2gpLmxlbmd0aCkge1xyXG4gICAgICAgICQoJ2h0bWwsIGJvZHknKS5hbmltYXRlKHtcclxuICAgICAgICAgICAgc2Nyb2xsVG9wOiAkKCQoaGFzaCkub2Zmc2V0KCkudG9wKVxyXG4gICAgICAgIH0sIDEwMDApO1xyXG4gICAgfVxyXG4gICAgKi9cclxuXHJcbiAgICAkKCcuZ2FsbGVyeS1wb3B1cCwgLndwLWJsb2NrLWdhbGxlcnknKS5lYWNoKGZ1bmN0aW9uKCkgeyAvLyB0aGUgY29udGFpbmVycyBmb3IgYWxsIHlvdXIgZ2FsbGVyaWVzXHJcbiAgICAgICAgJCh0aGlzKS5tYWduaWZpY1BvcHVwKHtcclxuICAgICAgICAgICAgZGVsZWdhdGU6ICdhJyxcclxuICAgICAgICAgICAgdHlwZTogJ2ltYWdlJyxcclxuICAgICAgICAgICAgY2xvc2VPbkNvbnRlbnRDbGljazogdHJ1ZSxcclxuICAgICAgICAgICAgY2xvc2VCdG5JbnNpZGU6IGZhbHNlLFxyXG4gICAgICAgICAgICBmaXhlZENvbnRlbnRQb3M6IHRydWUsXHJcbiAgICAgICAgICAgIHRMb2FkaW5nOiAnQ2FycmVnYW5kbyBhIGltYWdlbS4uLicsXHJcbiAgICAgICAgICAgIG1haW5DbGFzczogJ21mcC1uby1tYXJnaW5zIG1mcC1mYWRlJyxcclxuICAgICAgICAgICAgcmVtb3ZhbERlbGF5OiAzMDAsXHJcbiAgICAgICAgICAgIGdhbGxlcnk6IHtcclxuICAgICAgICAgICAgICAgIGVuYWJsZWQ6IHRydWUsXHJcbiAgICAgICAgICAgICAgICBuYXZpZ2F0ZUJ5SW1nQ2xpY2s6IHRydWUsXHJcbiAgICAgICAgICAgICAgICBwcmVsb2FkOiBbMCwxXSAvLyBXaWxsIHByZWxvYWQgMCAtIGJlZm9yZSBjdXJyZW50LCBhbmQgMSBhZnRlciB0aGUgY3VycmVudCBpbWFnZVxyXG4gICAgICAgICAgICB9LFxyXG4gICAgICAgICAgICBpbWFnZToge1xyXG4gICAgICAgICAgICAgICAgdEVycm9yOiAnQSBpbWFnZW0gbsOjbyBwb2RlIHNlciBjYXJyZWdhZGEuJyxcclxuICAgICAgICAgICAgfSxcclxuICAgICAgICB9KTtcclxuICAgIH0pO1xyXG59KTsiXSwiZmlsZSI6Im1haW4ubWluLmpzIn0=
